<template>
  <div class="modal">
    <div class="inner">
    <iframe width="560" height="315" :src="'https://www.youtube.com/embed/'+currentView.videoId" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <span class="close" @click="closePopup">X</span>
      <p class="nombre">{{currentView.nombre}}</p>
      <p class="descripcion">{{currentView.descripcion}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["closePopup", "currentView"],
};
</script>

<style lang="scss" scoped>
.modal {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: 0.5);

  .inner {
    width: 45%;

    background-color: #000000;
    position: fixed;
    top: 15%;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include phone {
      width: 80%;
      left: 45%;
    }

    .close {
      font-family: inherit;
      font-weight: bold;
      font-size: 2rem;
      color: white;
      position: absolute;
      top: 0;
      right: -1.5rem;
      cursor: pointer;

      @include phone {
        top: 1%;
      }
    }

    p {
      color: white;
      max-width: 90%;
    }

    iframe {
      margin-bottom: 1rem;
      width: 100% !important;
    }

    .nombre {
      color: $main-color;
      padding-left: 10px;
      margin-bottom: 10px;
    }

    .descripcion {
      padding-left: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>